import { renderTabsByDataset } from "../util/tabs/tabs-render";

export class HomeRankingProductTabsRender {
    public static renderActive(tabs: HTMLElement[], panels: HTMLElement[], parentCategoryId: string): void {
        renderTabsByDataset(tabs, panels, "parentCategoryId", parentCategoryId);
    }
}
